import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
    return twMerge(clsx(inputs));
}

export function formatNumber(num: number): string {
    if (num < 1000) {
        return num.toString();
    } else if (num >= 1000 && num < 1_000_000) {
        return (num / 1000).toFixed(1) + "k";
    } else if (num >= 1_000_000 && num < 1_000_000_000) {
        return (num / 1_000_000).toFixed(1) + "M";
    } else if (num >= 1_000_000_000 && num < 1_000_000_000_000) {
        return (num / 1_000_000_000).toFixed(1) + "B";
    } else {
        return (num / 1_000_000_000_000).toFixed(1) + "T";
    }
}

export function formatCurrency(value: number): string {
    return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
    }).format(value);
}

export function formatDate(date: Date): string {
    return `${date.toLocaleDateString()} ${date.toLocaleTimeString()}`;
}

export default function getGreeting(): string {
    const now = new Date();
    const hours = now.getHours();

    if (hours >= 5 && hours < 12) {
        return "Good Morning";
    } else if (hours >= 12 && hours < 17) {
        return "Good Afternoon";
    } else if (hours >= 17 && hours < 21) {
        return "Good Evening";
    } else {
        return "Good Night";
    }
}
